import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import ErrorBoundary from '../../ErrorBoundary';

const DuplicatePreviewItemCollections = ({ file }) => {
  const intl = useIntl();

  if (!file.collections || file.collections.length === 0) {
    return null;
  }

  return (
    <ErrorBoundary>
      <li className="duplicated-preview-detail">
        <h5>{intl.formatMessage({ defaultMessage: 'Collections:' })}</h5>
        <div className="duplicated-preview-detail-content">
          <div className="file-tags-list tags-list">
            {file.collections.map(collection => (
              <a
                id={`collection-${collection.uuid}`}
                key={`collection-${collection.uuid}`}
                className="tag tag-label"
                target="_blank"
                rel="noopener noreferrer"
                href={`/collections/${collection.uuid}`}
              >
                {collection.name}
              </a>
            ))}
          </div>
        </div>
      </li>
    </ErrorBoundary>
  );
};

DuplicatePreviewItemCollections.propTypes = {
  file: PropTypes.object.isRequired,
};

export default DuplicatePreviewItemCollections;
